//import axios from "axios/index";
import Global from '../../global';
//import mergeJSON from "merge-json";
import ClickstreamConfig from '../../config/clickstream';
import buildVersion from '../../version';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isNaN from 'lodash/isNaN';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import cloneDeep from 'lodash/cloneDeep';
import pull from 'lodash/pull';
import isArray from 'lodash/isArray';
import forOwn from 'lodash/forOwn';
import { Http } from '../http';
import axiosInstance from './axios-instance';
import { getSCLoggerUID } from '../../utils/logging';

export function getStaticLogData(logData) {
  const { index } = ClickstreamConfig();
  const sc_logger_uid = getSCLoggerUID();
  const { environment, podName, systemId } = Global.config;
  const {
    brand,
    subBrand,
    langISO2,
    offering,
    publicationId,
    countryISO3,
    currency,
    globalSessionId,
    playerSessionId,
    productPackage,
    parentProductPackage,
    cid
  } = logData;

  const data = {
    eventHeader: {
      environment: environment,
      target: index,
      userData: {
        cid,
        brand,
        offering,
        publicationId,
        countryISO3,
        currency
      },
      sc_logger_uid: sc_logger_uid
    },
    sessionData: {
      globalSessionId,
      playerSessionId
    },
    clientData: {
      version: buildVersion,
      subBrand,
      language: langISO2,
      productPackage,
      parentProductPackage
    },
    serverData: {
      serverName: podName,
      systemID: systemId
    }
  };

  return data;
}

export function removeEmptyObjectProps(obj) {
  return (function prune(current) {
    forOwn(current, function(value, key) {
      if (
        isUndefined(value) ||
        isNull(value) ||
        isNaN(value) ||
        (isString(value) && isEmpty(value)) ||
        (isObject(value) && isEmpty(prune(value)))
      ) {
        delete current[key];
      }
    });
    // remove any leftover undefined values from the delete
    // operation on an array
    if (isArray(current)) pull(current, undefined);

    return current;
  })(cloneDeep(obj)); // Do not modify the original object, create a clone instead
}

export default {
  sendEventToClickstream: finalData => {
    const { endpoint } = ClickstreamConfig();
    const headers = { 'content-type': 'application/json' };
    return new Http(axiosInstance.get()).post(
      {},
      endpoint,
      JSON.stringify(finalData),
      {},
      false,
      headers
    );
  }
};
